export default __webpack_public_path__ + "static/media/banner1.f4ce7331.png";